import React, { useState, useEffect } from "react";
import { Container,  Navbar } from "react-bootstrap";
import { Link } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScroll from "../components/useScroll";
import LangBtn from "../components/DComponent/LangBtn";

interface Navbar1Props {
  enableScrollEffect?: boolean;
  className?: string;
}

const Navbar1: React.FC<Navbar1Props> = ({ enableScrollEffect = true, className }) => {
  const { t } = useTranslation();
  const navClassFromScroll = useScroll();
  const navClass = enableScrollEffect ? navClassFromScroll : "";
  const [direction, setDirection] = useState<"ltr" | "rtl">("ltr");
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    const storedDir = localStorage.getItem("dir") as "ltr" | "rtl";
    if (storedDir) {
      setDirection(storedDir);
      document.documentElement.dir = storedDir;
    }
  }, []);

  const i18nextLng = window.localStorage.getItem("i18nextLng");

  useEffect(() => {
    const handleStorageChange = () => {
      const newDir = localStorage.getItem("dir") as "ltr" | "rtl";
      if (newDir && newDir !== direction) {
        setDirection(newDir);
        document.documentElement.dir = newDir;
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [direction]);

  const toggle = () => setIsOpen(!isOpen);
  const marginClass = direction === "rtl" ? "me-auto" : "ms-auto";

  const navItems = [
    { path: "/", label: t("navbar.home") },
    { path: "about", label: t("navbar.about") },
    { path: "services", label: t("navbar.services") },
    { path: "work", label: t("navbar.work") },
    { path: "contact", label: t("navbar.contact") },
  ];

  return (
    <nav
      className={`navbar navbar-expand-lg fixed-top navbar-custom tarnsperant-sticky ${navClass} ${className}`}
      id="navbar"
    >
      <Container>
        <Link className="navbar-brand" to="#!">
          <h1 className={`fs-4 fw-bold mb-0 text-white text-nowrap`}>
            {i18nextLng === "ar" ? "رواسي كريستال" : "Rawasi Kristal"}
          </h1>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
          onClick={toggle}
        >
          <i className="mdi mdi-menu text-white"></i>
        </button>
        <Navbar.Collapse id="navbarSupportedContent" in={isOpen}>
          <ul className={`navbar-nav text-white p-0 ${marginClass} navbar-center`}>
            {navItems.map((item) => (
              <li key={item.path} className={`nav-item`}>
                {item.path === "/" ? (
                  <RouterLink
                    to={item.path}
                    className="nav-link cursor-pointer"
                    onClick={() => setIsOpen(false)}
                  >
                    {item.label}
                  </RouterLink>
                ) : (
                  <Link
                    to={item.path}
                    smooth={true}
                    duration={500}
                    className="nav-link cursor-pointer"
                    onClick={() => setIsOpen(false)}
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
            <li className="nav-item">
              <RouterLink to="/blogs" className="nav-link" onClick={() => setIsOpen(false)}>
                {t("navbar.blogs") || "Blogs"}
              </RouterLink>
            </li>
            <li className={`nav-item ${navClass ? "text-black" : "text-white"}`}>
              <LangBtn />
            </li>
          </ul>
        </Navbar.Collapse>
      </Container>
    </nav>
  );
};

export default Navbar1;
